import React, { useEffect, useState } from 'react';
import { navbarRef } from './HeaderComponent';
import { useRouter } from 'next/router';
import { useDispatch, useStore } from '@globalStore/storeProvider';

import axios from 'axios';
import { JOB_BOARD_COMPILER_BASE_URL } from '@lib/api';
import DemoClassFormButton from '@components/local/courses/forms/demo-class-form/DemoClassFormButton';

import cn from 'classnames';
import woodStyleClockIcon from '@assets/bytes/clock-front-color.png';
import Image from 'next/image';
import { DateTimeFormatter } from '@utils/utils';
import { Primary } from 'stories/Button.stories';
import { sourceType } from '../widgets/ContactUs';

function CustomCourseBanner({
  title = 'From Non-Tech to Software Engineer in 2025',
  date = 'May 24',
  registerLink = 'https://link.almabetter.com/U381',
  isVisible = true,
}) {
  const [isStripOpen, setIsStripOpen] = useState(isVisible);
  const router = useRouter();

  const { nextCohort } = useStore();
  const dispatch = useDispatch();

  const headerPosition =
    typeof window !== undefined &&
    window?.getComputedStyle?.(navbarRef.current)?.getPropertyValue('position');

  const closeStripBanner = () => {
    setIsStripOpen(false);
    dispatch({ type: 'SET_STRIP_BANNER', payload: false });
  };

  useEffect(() => {
    dispatch({ type: 'SET_STRIP_BANNER', payload: isVisible });
  }, [isVisible]);

  const RegisterButton = ({ isMobile = false }) => {
    const handleNavigate = () => {
      window.open(registerLink, '_blank');
    };
    return (
      <>
        <Primary onClick={handleNavigate} size={'small'} label={'Register Now'} />
      </>
    );
  };

  return (
    <>
      {isStripOpen && (
        <>
          {/* Desktop */}
          <section className="sticky top-[4rem]  z-40 hidden h-[4rem] w-full items-center justify-evenly bg-[url('/assets/strips/gradient-course.png')] bg-cover font-satoshi-medium  text-[14px] font-medium leading-5 md:flex md:h-14 md:justify-center md:py-2 md:pr-0 md:text-sm">
            <div className="flex items-center justify-center gap-2">
              <div className={'flex items-center gap-2'}>
                <>
                  <img src="/assets/strips/rocket2.png" alt="" className="ml-2 h-8" />
                  <p className="self-start font-satoshi-medium text-[18px] leading-8">{title}</p>
                </>
              </div>

              <div className={'flex'}>
                <div className="flex items-center gap-2">
                  <img src="/assets/strips/calendar.png" alt="" className="h-8" />
                  <p className="font-satoshi-bold text-[20px]">Free Masterclass on {date}</p>
                </div>
              </div>

              <div className={''}>
                <RegisterButton />
              </div>
            </div>
          </section>
          {/* Mobile */}
          <div className="sticky top-[4rem] z-40 grid h-auto w-full grid-rows-[1fr] bg-[url('/assets/strips/mob-gradient-course.png')] bg-cover p-2  md:hidden">
            <div className="flex items-center gap-2">
              <div className="grid place-items-center">
                <img
                  src="/assets/strips/rocket2.png"
                  alt=""
                  className="mr-2 flex h-[3rem] items-center justify-center"
                />
              </div>
              <div className="flex flex-1 flex-col gap-0">
                <p className="self-start font-satoshi-bold text-[18px] leading-tight">
                  Free Masterclass on {date}
                </p>
                <p className="self-start font-satoshi-medium text-[16px] leading-tight">{title}</p>
              </div>
              <div className={'flex items-center justify-center'}>
                <RegisterButton />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default CustomCourseBanner;
